import { Box, Image, Spacer } from '@dtx-company/shared-components/src'
import { LargeProductSuitCardData } from '../types'
import { asText } from '@prismicio/client'
import { prismicCachedImage } from '@app/prismic/src/utils'
import CTAButton from './CTAButton'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'
import React from 'react'
import ValuePropsColumns from './ValuePropsColumns'

const LargeProductSuitCardMobile: React.FC<{ data?: LargeProductSuitCardData }> = ({ data }) => {
  if (!data) return null

  const isCreateFlowcodeBtn = data.button_label?.toLowerCase() === 'create a flowcode'
  const hasValueProps =
    Boolean(data.value_props_list?.length) && Boolean(data.value_props_images?.length)

  return (
    <Box px="23px">
      <Box maxWidth="544px" mx="auto" flexDirection="column" alignItems="center">
        {data['logo-title']?.url && (
          <Box flexDirection="column" alignItems="center">
            <Image
              maxWidth="153px"
              src={prismicCachedImage(data['logo-title']?.url)}
              alt={data['logo-title']?.alt ?? 'logo'}
            />
            <Spacer mb="16px" />
          </Box>
        )}
        <PrismicText
          richTextField={data.subheader}
          variant="display/medium"
          maxWidth="430px"
          lineHeight="30px"
          fontSize={{ _: '24px', md: '28px' }}
          textAlign="center"
        />
        {asText(data.description) && (
          <>
            <Spacer mb="16px" />
            <PrismicText
              richTextField={data.description}
              variant="body/medium"
              textAlign="center"
            />
          </>
        )}
        <Spacer mb="33px" />
        <Image src={prismicCachedImage(data.image?.url ?? '')} alt={data.image?.alt ?? ''} />
        {hasValueProps && (
          <>
            <Spacer mt="33px" />
            <ValuePropsColumns
              valuePropsText={data.value_props_list}
              valuePropsImages={data.value_props_images}
            />
          </>
        )}
        <Spacer mb="33px" />
        <Box flexDirection="column" alignItems="center">
          <CTAButton
            label={data.button_label}
            href={isCreateFlowcodeBtn ? undefined : data.button_href?.url}
            onClick={isCreateFlowcodeBtn ? () => window.scroll(0, 0) : undefined}
            variant={data.button_variant}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default LargeProductSuitCardMobile
